import { Component, computed, DestroyRef, inject, LOCALE_ID, OnInit, signal } from '@angular/core';
import { ViewOrderComponent } from '../../../../components/admin-dashboard-component/orders/view-order-component/view-order-component';
import { ViewOrderHistory } from '../../../../components/admin-dashboard-component/orders/view-order-history/view-order-history';
import { ViewOrderDetails } from '../../../../components/admin-dashboard-component/orders/view-order-details/view-order-details';
import { SubmitButton } from '../../../../shared/ui/Buttons/submit-button/submit-button';
import { ActivatedRoute } from '@angular/router';
import { ViewOrderRelatedInvoices } from '../../../../components/admin-dashboard-component/orders/order-invoices/view-order-related-invoices/view-order-related-invoices';
@Component({
  selector: 'app-view-order',
  standalone: true,
  imports: [ViewOrderHistory, ViewOrderDetails, ViewOrderRelatedInvoices],
  templateUrl: './view-order.html',
  styleUrl: './view-order.scss',
})
export class ViewOrder implements OnInit {
  private locale = inject(LOCALE_ID);
  private route = inject(ActivatedRoute);
  isArabic = computed(() => this.locale.startsWith('ar'));
  activeTab = signal(1);
  role = signal<'admin' | 'pharmacist'>('admin');
  orderId = signal('');
  private destroyRef = inject(DestroyRef);
  onSetActiveTab(id: number) {
    this.activeTab.set(id);
  }

  ngOnInit() {
    const extractedRole = this.route.snapshot.data;
    if (extractedRole['role']) this.role.set(extractedRole['role']);

    const subscription = this.route.paramMap.subscribe((params) => {
      const id = params.get('id');

      if (id) {
        this.orderId.set(id);
      }
    });
    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }
  tabs = signal([
    {
      id: 1,
      label: this.isArabic() ? 'تفاصيل الطلب' : 'Details',
    },
    {
      id: 2,
      label: this.isArabic() ? 'تاريخ الطلبات' : 'History',
    },
    {
      id: 3,
      label: this.isArabic() ? 'الفواتير' : 'Related Invoices',
    },
  ]);
}
